var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_3348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 4.27148L12.1934 5.79815L8.94004 9.05148L6.27337 6.38482L1.33337 11.3315L2.27337 12.2715L6.27337 8.27148L8.94004 10.9382L13.14 6.74482L14.6667 8.27148V4.27148H10.6667Z",
    fill: "#EA580B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_3348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.271484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingup1);
export default __webpack_public_path__ + "static/media/Trending up1.28816f04bc85becfd63f23f481e23a02.svg";
export { ForwardRef as ReactComponent };